<template>
  <div>
    <!-- Header with Date Range and Export -->
    <v-row class="mt-4">
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center ga-1">
            <div style="font-size: 30px; font-weight: 700">{{ $t('overview') }}</div>
            <div class="mx-2" style="background-color: #c9d6f2; height: 30px; width: 2px"></div>
            <span style="font-size: 18px" class="font-weight-medium mr-2">{{ $t('start_end_date') }}</span>
            <v-menu v-model="datePickerMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ props }">
                <v-text-field v-bind="props" :value="dateRangeText" readonly variant="outlined" density="compact" hide-details style="width: 300px; position: relative">
                  <v-icon size="small" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%)" color="#76237E"> mdi-calendar </v-icon>
                </v-text-field>
              </template>
              <v-card class="date-picker-card">
                <v-date-picker v-model="selectedDates" @update:model-value="updateDateRange" color="#76237E" elevation="0" rounded="lg" multiple="range" />
                <v-card-actions class="date-picker-actions justify-end">
                  <v-btn variant="text" color="#666" @click="cancelDateSelection">Cancel</v-btn>
                  <v-btn variant="flat" color="#76237E" :disabled="!selectedDates.length || !hasDateSelectionChanged" @click="confirmDateSelection"> OK </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>

          <ExportButton :small="false" label="Export" @click="exportAllData" />
        </div>
      </v-col>
    </v-row>

    <!-- KPI Cards -->
    <v-row class="mt-4">
      <v-col cols="12" sm="6" md="2">
        <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #f4e3a9 0%, #ddfdff 100%)">
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Total Users</div>
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Visit</div>
          <div class="card-value-bottom-left">{{ formatNumber(overview.totalUsersVisit) }}</div>
          <v-icon size="80" style="position: absolute; right: 5px; bottom: 5px; z-index: 1; opacity: 0.5" color="primary">mdi-account-group</v-icon>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #ffe7f7 0%, #ffcbbe 100%)">
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">New User</div>
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Visit</div>
          <div class="card-value-bottom-left">{{ formatNumber(overview.newUserVisit) }}</div>
          <v-icon size="80" style="position: absolute; right: 5px; bottom: 5px; z-index: 1; opacity: 0.5" color="secondary">mdi-account-plus</v-icon>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #e1f6ff 0%, #fcd7ff 100%)">
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Total Created</div>
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Tax Forms</div>
          <div class="card-value-bottom-left">{{ formatNumber(overview.totalCreatedTaxForms) }}</div>
          <v-icon size="80" style="position: absolute; right: 5px; bottom: 5px; z-index: 1; opacity: 0.5" color="info">mdi-file-document-multiple</v-icon>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #ffd2d4 0%, #d3d6ff 100%)">
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Completed Forms</div>
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">(Tax Calculated)</div>
          <div class="card-value-bottom-left">{{ formatNumber(overview.completedForms) }}</div>
          <v-icon size="80" style="position: absolute; right: 5px; bottom: 5px; z-index: 1; opacity: 0.5" color="success">mdi-file-check</v-icon>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #bbcaff 0%, #bcfbff 100%)">
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Total Product</div>
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Clicks</div>
          <div class="card-value-bottom-left">{{ formatNumber(overview.totalProductsClick) }}</div>
          <v-icon size="80" style="position: absolute; right: 5px; bottom: 5px; z-index: 1; opacity: 0.5" color="warning">mdi-cursor-default-click</v-icon>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-card class="pa-4 dashboard-top-cards" style="background: linear-gradient(270deg, #d6dc29 0%, #c5ebff 100%)">
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Recommendation</div>
          <div style="font-size: 16px; position: relative; z-index: 2" class="font-weight-medium">Like</div>
          <div class="card-value-bottom-left">{{ formatNumber(overview.totalRecommendationLike) }}</div>
          <v-icon size="80" style="position: absolute; right: 5px; bottom: 5px; z-index: 1; opacity: 0.5" color="pink">mdi-thumb-up</v-icon>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="d-flex align-stretch">
      <v-col cols="8" class="d-flex flex-column ga-4">
        <!-- Daily Trend -->
        <v-card class="pa-4 flex-grow-1" style="border-radius: 12px">
          <div class="d-flex align-center mb-3">
            <v-icon class="mr-2" color="primary" size="small">mdi-chart-line</v-icon>
            <span style="font-size: 16px; font-weight: 700">Daily Trend</span>
          </div>
          <DailyTrendChart :data="dailyTrendData" />
        </v-card>

        <v-row>
          <!-- Customer Satisfaction -->
          <v-col class="">
            <v-card class="pa-4 d-flex flex-column flex-grow-1 h-100" style="border-radius: 12px">
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                  <v-icon class="mr-2" color="info" size="small">mdi-emoticon-happy</v-icon>
                  <span style="font-size: 16px; font-weight: 700">Customer Satisfaction</span>
                </div>
                <ExportButton @click="exportSatisfactionData" tooltip="Export to CSV" />
              </div>

              <div class="d-flex flex-grow-1" style="gap: 12px">
                <v-card class="px-12 pa-3 d-flex flex-column justify-center satisfaction-card" style="border-radius: 8px" elevation="2">
                  <SatisfactionBreakdown :data="satisfactionData" />
                </v-card>

                <v-card class="pa-3 d-flex flex-column satisfaction-card" style="flex: 1; border-radius: 8px" elevation="2">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div style="font-size: 14px; font-weight: 700">Dislike Reasons</div>
                    <div class="text-caption text-medium-emphasis">{{ dislikeReasonsPage }} / {{ dislikeReasonsTotalPages }}</div>
                  </div>

                  <v-list density="compact" class="pa-0 dislike-reasons-list">
                    <v-list-item v-for="(reason, index) in paginatedDislikeReasons" :key="reason.code || reason.label || index" class="px-0 py-1">
                      <template v-slot:prepend>
                        <span class="text-caption mr-2 px-4">{{ (dislikeReasonsPage - 1) * dislikeReasonsPerPage + index + 1 }}.</span>
                      </template>
                      <v-list-item-title class="text-caption"> {{ reason.reason }} </v-list-item-title>
                    </v-list-item>
                  </v-list>

                  <!-- Pagination Controls -->
                  <div class="d-flex justify-center ga-2 mt-4">
                    <v-btn size="x-small" icon="mdi-chevron-left" variant="text" :disabled="dislikeReasonsPage === 1" @click="dislikeReasonsPage--"></v-btn>
                    <v-btn size="x-small" icon="mdi-chevron-right" variant="text" :disabled="dislikeReasonsPage === dislikeReasonsTotalPages" @click="dislikeReasonsPage++"></v-btn>
                  </div>
                </v-card>
              </div>
            </v-card>
          </v-col>

          <!-- Consent Overview -->
          <v-col class="d-flex flex-column" cols="4">
            <v-card class="pa-4 d-flex flex-column h-100" style="border-radius: 12px">
              <div class="d-flex align-center mb-3">
                <v-icon class="mr-2" color="primary" size="small">mdi-chart-bar</v-icon>
                <span style="font-size: 16px; font-weight: 700">Consent Overview</span>
              </div>
              <PieChart :data="consentOverviewPie" title="Consent Overview" :horizontal="false" :show-export="false" :custom-colors="['#43A047', '#E53935', '#FB8C00']" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col class="d-flex flex-column ga-4" cols="4">
        <!-- Access Channels -->
        <v-card class="pa-4 flex-grow-1" style="border-radius: 12px">
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="primary" size="small">mdi-chart-donut</v-icon>
              <span style="font-size: 16px; font-weight: 700">Access Channels</span>
            </div>
            <ExportButton @click="exportAccessChannels" tooltip="Export to CSV" />
          </div>
          <PieChart :data="accessChannelBreakdownPie" title="Access Channels" :horizontal="false" :show-export="false" />
        </v-card>

        <!-- New vs Returning Users -->
        <v-card class="pa-4 flex-grow-1" style="border-radius: 12px">
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="primary" size="small">mdi-account-multiple</v-icon>
              <span style="font-size: 16px; font-weight: 700">New vs Returning Users</span>
            </div>
            <ExportButton @click="exportNewVsReturningUsers" tooltip="Export to CSV" />
          </div>
          <PieChart :data="newVsReturningUsersPie" title="User Types" :horizontal="false" :show-export="false" />
        </v-card>
      </v-col>
    </v-row>

    <v-row class="">
      <!-- Usage Funnel by Form -->
      <v-col class="d-flex flex-column h-100" cols="12">
        <v-card class="pa-4 d-flex flex-column h-100" style="border-radius: 12px">
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="primary" size="small">mdi-chart-bar</v-icon>
              <span style="font-size: 16px; font-weight: 700">Usage Funnel by Form</span>
            </div>
            <ExportButton @click="exportUsageFunnelByForm" tooltip="Export to CSV" />
          </div>
          <div style="overflow-x: auto">
            <UsageFunnelTable :data="usageFunnelByForm" :show-export="false" />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tax Savings Result -->
    <v-row class="mt-4">
      <v-col cols="12">
        <v-card class="pa-4" style="border-radius: 12px">
          <div class="d-flex align-center mb-3">
            <v-icon class="mr-2" color="success" size="small">mdi-cash-multiple</v-icon>
            <span style="font-size: 16px; font-weight: 700">Customer Tax Savings Result</span>
          </div>
          <div style="overflow-x: auto">
            <TaxSavingsTable :data="taxSavingsData" />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Product CTR & Customer Income -->
    <v-row class="mt-4">
      <!-- CTR by Recommended Products -->
      <v-col class="d-flex flex-column min-h-100">
        <v-card class="pa-4 h-100 d-flex flex-column" style="border-radius: 12px">
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="warning" size="small">mdi-chart-bar</v-icon>
              <span style="font-size: 16px; font-weight: 700">CTR by Recommended Products</span>
            </div>
            <ExportButton @click="exportProductCtr" tooltip="Export to CSV" />
          </div>
          <div class="h-100" style="overflow-x: auto">
            <ProductCtrTable
              :data="productCtrData"
              :show-export="false"
              :paginated-data="paginatedProductCtrData"
              :sorted-data="sortedProductCtrData"
              :current-page="productCtrPage"
              :total-pages="productCtrTotalPages"
              :sort-order="productCtrSortOrder"
              @update:current-page="productCtrPage = $event"
              @update:sort-order="productCtrSortOrder = $event"
            />
          </div>
        </v-card>
      </v-col>

      <!-- Customer Income Distribution -->
      <v-col>
        <v-card class="pa-4" style="border-radius: 12px">
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="success" size="small">mdi-account-cash</v-icon>
              <span style="font-size: 16px; font-weight: 700">Customer Income Distribution</span>
            </div>
            <ExportButton @click="exportCustomerIncome" tooltip="Export to CSV" />
          </div>
          <div style="overflow-x: auto">
            <CustomerIncomeTable :data="customerIncomeData" :show-export="false" />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import UsageFunnelTable from '@/components/TaxDashboard/UsageFunnelTable.vue';
import PieChart from '@/components/TaxDashboard/PieChart.vue';
import TaxSavingsTable from '@/components/TaxDashboard/TaxSavingsTable.vue';
import SatisfactionBreakdown from '@/components/TaxDashboard/SatisfactionBreakdown.vue';
import ProductCtrTable from '@/components/TaxDashboard/ProductCtrTable.vue';
import CustomerIncomeTable from '@/components/TaxDashboard/CustomerIncomeTable.vue';
import DailyTrendChart from '@/components/TaxDashboard/DailyTrendChart.vue';
import ExportButton from '@/components/TaxDashboard/ExportButton.vue';

import { getTaxDashboardData } from '@/services/taxDashboardService';
import { useFormat } from '@/composables/TaxDashboard/useFormat';
import { useTransform, createPaginatedData } from '@/composables/TaxDashboard/useTransform';
import { useExport } from '@/composables/TaxDashboard/useExport';

export default {
  name: 'LiveToDateTab',
  components: {
    UsageFunnelTable,
    ExportButton,
    PieChart,
    TaxSavingsTable,
    SatisfactionBreakdown,
    ProductCtrTable,
    CustomerIncomeTable,
    DailyTrendChart,
  },
  setup() {
    const { formatNumber, formatStateDate, formatDisplayDate, getTodayDate } = useFormat();
    const { transformToPieChartFormat } = useTransform();
    const {
      exportAccessChannels: _exportAccessChannels,
      exportNewVsReturningUsers: _exportNewVsReturningUsers,
      exportUsageFunnelByForm: _exportUsageFunnelByForm,
      exportProductCtr: _exportProductCtr,
      exportCustomerIncome: _exportCustomerIncome,
      exportSatisfactionData: _exportSatisfactionData,
      exportAllData: _exportAllData,
    } = useExport();

    const loading = ref(false);
    const datePickerMenu = ref(false);
    const selectedDates = ref([]);
    const backupSelectedDates = ref([]);
    const startDate = ref(null);
    const endDate = ref(null);
    const lastSelectedDate = ref(null);

    const dateRangeText = computed(() => {
      if (startDate.value && endDate.value) {
        return `${formatDisplayDate(startDate.value)} - ${formatDisplayDate(endDate.value)}`;
      }
      return 'Select date range';
    });

    const hasDateSelectionChanged = computed(() => {
      if (!selectedDates.value.length && !backupSelectedDates.value.length) {
        return false;
      }
      if (selectedDates.value.length !== backupSelectedDates.value.length) {
        return true;
      }
      const sortedCurrent = [...selectedDates.value].sort();
      const sortedBackup = [...backupSelectedDates.value].sort();
      return JSON.stringify(sortedCurrent) !== JSON.stringify(sortedBackup);
    });

    watch(datePickerMenu, (newVal) => {
      if (newVal) {
        backupSelectedDates.value = [...selectedDates.value];
      }
    });

    const overview = ref({
      totalUsersVisit: 0,
      totalCreatedTaxForms: 0,
      completedForms: 0,
      newUserVisit: 0,
      totalProductsClick: 0,
      totalRecommendationLike: 0,
    });

    const consentOverview = ref({ totalVisitUsers: 0, acceptedConsentUsers: 0, cancelledConsentUsers: 0 });
    const usageFunnelByForm = ref([]);
    const accessChannelBreakdown = ref([]);
    const newVsReturningUsers = ref([]);
    const taxSavingsData = ref([]);
    const satisfactionData = ref({});
    const dislikeReasons = ref([]);
    const dislikeReasonsPage = ref(1);
    const dislikeReasonsPerPage = 5;

    const { paginatedData: paginatedDislikeReasons, totalPages: dislikeReasonsTotalPages } = createPaginatedData(dislikeReasons, dislikeReasonsPage, dislikeReasonsPerPage);

    const productCtrData = ref([]);
    const productCtrPage = ref(1);
    const productCtrPerPage = 5;
    const productCtrSortOrder = ref('desc');

    const {
      sortedData: sortedProductCtrData,
      paginatedData: paginatedProductCtrData,
      totalPages: productCtrTotalPages,
    } = createPaginatedData(productCtrData, productCtrPage, productCtrPerPage, (a, b) => (productCtrSortOrder.value === 'desc' ? b.ctr - a.ctr : a.ctr - b.ctr));

    watch(productCtrSortOrder, () => {
      productCtrPage.value = 1;
    });

    const customerIncomeData = ref([]);
    const dailyTrendData = ref([]);

    const accessChannelBreakdownPie = computed(() => {
      return transformToPieChartFormat(accessChannelBreakdown.value);
    });

    const newVsReturningUsersPie = computed(() => {
      return transformToPieChartFormat(newVsReturningUsers.value);
    });

    const consentOverviewPie = computed(() => {
      const data = consentOverview.value;
      if (!data || !data.totalVisitUsers) return [];
      const accepted = data.acceptedConsentUsers || 0;
      const cancelled = data.cancelledConsentUsers || 0;
      const denied = Math.max(data.totalVisitUsers - accepted - cancelled, 0);
      const total = data.totalVisitUsers;
      return [
        { label: 'Accepted Consent', value: accepted, percentage: total > 0 ? Math.round((accepted / total) * 100) : 0 },
        { label: 'Denied Consent', value: denied, percentage: total > 0 ? Math.round((denied / total) * 100) : 0 },
        { label: 'Cancelled Consent', value: cancelled, percentage: total > 0 ? Math.round((cancelled / total) * 100) : 0 },
      ];
    });

    const updateDateRange = (dates) => {
      if (dates && dates.length > 0) {
        const sortedDates = dates.sort((a, b) => new Date(a) - new Date(b));
        const start = formatStateDate(sortedDates[0]);
        const end = formatStateDate(sortedDates[sortedDates.length - 1]);
        startDate.value = start;
        endDate.value = end;

        if (sortedDates.length === 1) {
          endDate.value = startDate.value;
          const single = formatStateDate(sortedDates[0]);
          if (lastSelectedDate.value === single) {
            datePickerMenu.value = false;
            loadData();
            lastSelectedDate.value = null;
            return;
          }
          lastSelectedDate.value = single;
        }

        if (sortedDates.length >= 2) {
          datePickerMenu.value = false;
          lastSelectedDate.value = null;
          loadData();
        }
      } else {
        if (lastSelectedDate.value) {
          startDate.value = lastSelectedDate.value;
          endDate.value = lastSelectedDate.value;
          selectedDates.value = [lastSelectedDate.value, lastSelectedDate.value];
          datePickerMenu.value = false;
          loadData();
          lastSelectedDate.value = null;
        }
      }
    };

    const confirmDateSelection = () => {
      if (selectedDates.value && selectedDates.value.length > 0) {
        const sortedDates = [...selectedDates.value].sort((a, b) => new Date(a) - new Date(b));
        startDate.value = formatStateDate(sortedDates[0]);
        endDate.value = formatStateDate(sortedDates[sortedDates.length - 1]);
        selectedDates.value = [startDate.value, endDate.value];
        datePickerMenu.value = false;
        lastSelectedDate.value = null;
        loadData();
      } else if (lastSelectedDate.value) {
        startDate.value = lastSelectedDate.value;
        endDate.value = lastSelectedDate.value;
        selectedDates.value = [lastSelectedDate.value, lastSelectedDate.value];
        datePickerMenu.value = false;
        loadData();
        lastSelectedDate.value = null;
      }
    };

    const cancelDateSelection = () => {
      selectedDates.value = [...backupSelectedDates.value];
      datePickerMenu.value = false;
      lastSelectedDate.value = null;
    };

    const exportSatisfactionData = () => {
      _exportSatisfactionData(satisfactionData.value, dislikeReasons.value);
    };

    const exportAccessChannels = () => {
      _exportAccessChannels(accessChannelBreakdownPie.value);
    };

    const exportNewVsReturningUsers = () => {
      _exportNewVsReturningUsers(newVsReturningUsersPie.value);
    };

    const exportUsageFunnelByForm = () => {
      _exportUsageFunnelByForm(usageFunnelByForm.value);
    };

    const exportProductCtr = () => {
      _exportProductCtr(sortedProductCtrData.value);
    };

    const exportCustomerIncome = () => {
      _exportCustomerIncome(customerIncomeData.value);
    };

    const exportAllData = async () => {
      await _exportAllData({
        accessChannelBreakdownPie: accessChannelBreakdownPie.value,
        newVsReturningUsersPie: newVsReturningUsersPie.value,
        usageFunnelByForm: usageFunnelByForm.value,
        productCtrData: sortedProductCtrData.value,
        customerIncomeData: customerIncomeData.value,
        startDate: startDate.value,
        endDate: endDate.value,
        dateRangeText: dateRangeText.value,
      });
    };

    const loadData = async () => {
      loading.value = true;
      try {
        const data = await getTaxDashboardData(dateRangeText.value);

        overview.value = data.overview;
        consentOverview.value = data.consentOverview;
        usageFunnelByForm.value = data.usageFunnelByForm;
        accessChannelBreakdown.value = data.accessChannelBreakdown;
        newVsReturningUsers.value = data.newVsReturningUsers;
        taxSavingsData.value = data.taxSavingsData;
        satisfactionData.value = data.satisfactionData;
        dislikeReasons.value = data.satisfactionData.dislikeReasons || [];
        productCtrData.value = data.productCtrData;
        customerIncomeData.value = data.customerIncomeData;
        dailyTrendData.value = data.dailyTrendData;

        dislikeReasonsPage.value = 1;
        productCtrPage.value = 1;
      } finally {
        loading.value = false;
      }
    };

    const initializeDate = () => {
      const currentDate = getTodayDate();
      startDate.value = currentDate;
      endDate.value = currentDate;
      selectedDates.value = [startDate.value, endDate.value];
    };

    onMounted(() => {
      initializeDate();
      loadData();
    });

    return {
      loading,
      datePickerMenu,
      selectedDates,
      startDate,
      endDate,
      dateRangeText,
      hasDateSelectionChanged,
      overview,
      consentOverview,
      consentOverviewPie,
      usageFunnelByForm,
      accessChannelBreakdownPie,
      newVsReturningUsersPie,
      taxSavingsData,
      satisfactionData,
      dislikeReasons,
      dislikeReasonsPage,
      dislikeReasonsPerPage,
      paginatedDislikeReasons,
      dislikeReasonsTotalPages,
      productCtrData,
      productCtrPage,
      productCtrSortOrder,
      paginatedProductCtrData,
      sortedProductCtrData,
      productCtrTotalPages,
      customerIncomeData,
      dailyTrendData,
      formatNumber,
      updateDateRange,
      confirmDateSelection,
      cancelDateSelection,
      exportSatisfactionData,
      exportAccessChannels,
      exportNewVsReturningUsers,
      exportUsageFunnelByForm,
      exportProductCtr,
      exportCustomerIncome,
      exportAllData,
      loadData,
    };
  },
};
</script>

<style scoped>
.dashboard-top-cards {
  border-radius: 12px;
  height: 120px;
  position: relative;
  overflow: hidden;
}

.card-value-bottom-left {
  position: absolute;
  bottom: 0px;
  left: 16px;
  z-index: 2;
  font-weight: 700;
  font-size: 35px;
}

/* Satisfaction section cards */
.satisfaction-card {
  background-color: #fafafa !important;
  transition: box-shadow 0.2s ease;
}

.satisfaction-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Dislike reasons list background */
.dislike-reasons-list {
  background-color: transparent !important;
  min-height: 200px !important;
  display: flex !important;
  flex-direction: column !important;
}

.dislike-reasons-list :deep(.v-list-item) {
  background-color: transparent !important;
  border-radius: 4px;
  margin-bottom: 2px;
  min-height: 36px !important;
}

.dislike-reasons-list :deep(.v-list-item:nth-child(odd)) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.dislike-reasons-list :deep(.v-list-item:nth-child(even)) {
  background-color: rgba(255, 255, 255, 0.5) !important;
}

/* Date Picker Custom Styling */
:deep(.v-date-picker) {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

:deep(.v-date-picker-month__days) {
  column-gap: 0 !important;
  row-gap: 6px !important;
}

:deep(.v-date-picker-month__day) {
  margin: 0 !important;
}

:deep(.v-date-picker-month__day--selected .v-btn),
:deep(.v-date-picker-month__day--selected .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--selected .v-btn.v-btn--variant-flat) {
  background-color: #76237e !important;
  color: white !important;
}

:deep(.v-date-picker-month__day--range-start .v-btn),
:deep(.v-date-picker-month__day--range-start .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--range-start .v-btn.v-btn--variant-flat) {
  border-top-left-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  background-color: #76237e !important;
}

:deep(.v-date-picker-month__day--range-end .v-btn),
:deep(.v-date-picker-month__day--range-end .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--range-end .v-btn.v-btn--variant-flat) {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-top-right-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
  background-color: #76237e !important;
}

:deep(.v-date-picker-month__day--range-start.v-date-picker-month__day--range-end .v-btn),
:deep(.v-date-picker-month__day--range-start.v-date-picker-month__day--range-end .v-btn.v-btn--variant-elevated),
:deep(.v-date-picker-month__day--range-start.v-date-picker-month__day--range-end .v-btn.v-btn--variant-flat) {
  border-radius: 12px !important;
  background-color: #76237e !important;
}

:deep(.v-date-picker-month__day--selected .v-btn) {
  color: white !important;
  font-weight: 500 !important;
}

:deep(.v-date-picker-month__day--range-start .v-btn),
:deep(.v-date-picker-month__day--range-end .v-btn) {
  color: white !important;
  font-weight: 600 !important;
}

:deep(.v-date-picker-month__day:not(.v-date-picker-month__day--selected) .v-btn:hover) {
  background-color: rgba(118, 35, 126, 0.1) !important;
  border-radius: 8px !important;
}

:deep(.v-date-picker-month__day .v-btn .v-btn__overlay) {
  opacity: 0 !important;
}

:deep(.v-date-picker-month__day .v-btn .v-ripple__container) {
  opacity: 0.3 !important;
}

:deep(.v-picker__body) {
  background: white !important;
}

:deep(.v-date-picker-month) {
  padding: 0 12px !important;
}

:deep(.v-date-picker-header) {
  padding: 16px !important;
}

.date-picker-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.date-picker-actions {
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
  padding: 8px 12px !important;
}

.date-picker-actions .v-btn {
  min-width: 80px;
  font-weight: 600;
  text-transform: none;
}

.date-picker-actions .v-btn--disabled {
  opacity: 0.5;
}
</style>
